export default function ExAddedDate({ addedTime , addedBy}) {
  return (
    <>
      <span>Added by {addedBy} at: </span>
      <input
        type="datetime-local"
        className="prjdetails-date-without-icon"
        value={new Date(addedTime).toISOString().slice(0, 16)}
        readOnly
      />
    </>
  );
}
